<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 534 497"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <g transform="matrix(1,0,0,1,5.9952e-15,-18.506)">
      <g transform="matrix(1,0,0,1,-98.4325,-68.522)">
        <path
          :fill="fill"
          d="M365,87.028C394.153,87.841 419.351,106.066 438,105C473,103 469.048,93.606 487,96C502,98 512.837,114.558 524,122C548,138 619,190 630,285C640.931,379.402 591.628,422.291 577,437C562.372,451.709 530.621,475.739 516,487C501.379,498.261 473.607,521.233 459,547C444.393,572.767 436.723,584.423 428,583C419.277,581.577 423.14,487.168 458,452C492.86,416.832 532.637,408.827 535,361C537.363,313.173 514.8,296.038 503,296C491.2,295.962 471.912,299.386 464,316C464,316 463.585,340.997 458,354C452.415,367.003 447.103,377.053 425,384C390.721,394.773 411.118,437.201 365,438.945C318.882,437.201 339.279,394.773 305,384C282.897,377.053 277.585,367.003 272,354C266.415,340.997 266,316 266,316C258.088,299.386 238.8,295.962 227,296C215.2,296.038 192.637,313.173 195,361C197.363,408.827 237.14,416.832 272,452C306.86,487.168 310.723,581.577 302,583C293.277,584.423 285.607,572.767 271,547C256.393,521.233 228.621,498.261 214,487C199.379,475.739 167.628,451.709 153,437C138.372,422.291 89.069,379.402 100,285C111,190 182,138 206,122C217.163,114.558 228,98 243,96C260.952,93.606 257,103 292,105C310.649,106.066 335.847,87.841 365,87.028ZM365,396.937C361.598,396.891 356.234,396.267 354,393C354,393 352.347,392.516 357,384C361.653,375.484 361.487,372 365,372C368.513,372 368.347,375.484 373,384C377.653,392.516 376,393 376,393C373.766,396.267 368.402,396.891 365,396.937L365,396.937ZM434,335C432.286,331.988 427.295,327.005 415,330C402.705,332.995 394.945,344.732 394,357C394,357 408,367 424,355C436.649,345.513 434,335 434,335ZM296,335C297.714,331.988 302.705,327.005 315,330C327.295,332.995 335.055,344.732 336,357C336,357 322,367 306,355C293.351,345.513 296,335 296,335Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: ["fill"]
};
</script>
